import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import times from "helpers/times"
import clone from 'clone'
import numeral from 'numeral'
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import moment from 'moment'

class ClosingAverages extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			filtered: [],
			times: times(),
			sorted: [],
			model: {
				average_home_price: 0,
				average_square_feet: 0,
				average_ppsqft: 0,
				total: 0,
				totalHomePrice: 0,
				totalSqft: 0,
			},
			finalGross: {
				number: 0,
				sqft: 0,
				price: 0,
			},
			data: [],
			daysToClose: []
		}
	}

	componentDidMount() {
		this.buildTable()
		this.buildDaysToCloseTable()
	}

	componentDidUpdate(prevProps) {
		if (this.props !== prevProps) {
			this.buildTable()
			this.buildDaysToCloseTable()
		}
	}

	columns = () => {
		return [
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Total Closings",
				accessor: "total",
				filterMethod: (f, r) => helpers.tableText(f, r, "total"),
				Cell: (v) => {
					return numeral(v.value).format("0,0")
				},
				Footer: (props) => {
					let total = 0
					_.forEach(props.data, (v) => {
						if (v.total) {
							total += v.total
						}
					})
					if (typeof total == "number") {
						return total.toLocaleString()
					}
					return total
				},
			},
			{
				Header: "Average Home Price",
				accessor: "average_home_price",
				Cell: (v) => {
					return numeral(v.value).format("$0,0")
				},
				/* Footer: (props) => {
					let total = 0
					let count = 0
					_.forEach(this.props.payload.closings.current, (v) => {
						total += v.price
						count++
					})
					let average = Math.round(total / count).toLocaleString()
					return `$${average}`
				}, */
			},
			{
				Header: "Average Sq. Ft.",
				accessor: "average_square_feet",
				Cell: (v) => {
					return numeral(v.value).format("0,0")
				},
				/* Footer: (props) => {
					let total = 0
					let count = 0
					_.forEach(this.props.payload.closings.current, (v) => {
						total += v.sqft
						count++
					})
					let average = Math.round(total / count).toLocaleString()
					return `${average}`
				}, */
			},
			{
				Header: "Average Price per Sq.ft.",
				accessor: "average_ppsqft",
				Cell: (v) => {
					return numeral(v.value).format("$0,0")
				},
				/* Footer: (props) => {
					let total = 0
					let sqftTotal = 0
					_.forEach(this.props.payload.closings.current, (v) => {
						sqftTotal += v.sqft
						total += v.price
					})
					let average = Math.round(total / sqftTotal).toLocaleString()
					return `$${average}`
				}, */
			},
		]
	}

	daysToCloseColumns = () => {
		return [
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Average Days To Close",
				accessor: "average",
				Cell: (v) => {
					return numeral(v.value).format("0,0")
				},
				Footer: (props) => helpers.tableAverages(props, "average", "0,0"),
			},
			{
				Header: "Lowest Days To Close",
				accessor: "lowest",
				filterMethod: (f, r) => helpers.tableText(f, r, "lowest"),
				Cell: (v) => {
					return numeral(v.value).format("0,0")
				},
			},
			{
				Header: "Highest Days To Close",
				accessor: "highest",
				filterMethod: (f, r) => helpers.tableText(f, r, "highest"),
				Cell: (v) => {
					return numeral(v.value).format("0,0")
				},
			},
			{
				Header: "Number of Closings",
				accessor: "num_closings",
				filterMethod: (f, r) => helpers.tableText(f, r, "num_closings"),
				Cell: (v) => {
					return numeral(v.value).format("0,0")
				},
				Footer: (props) => helpers.tableTotals(props, "num_closings", "0,0"),
			},
		]
	}

	buildTable() {
		let state = _.cloneDeep(this.state)
		let store = {}
		_.forEach(this.props.payload.closings.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type || !builder || !v.sqft || !v.price) {
				return
			}
			let path = `["${type.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name].total++
			store[type.name][builder.name].totalHomePrice += v.price
			store[type.name][builder.name].totalSqft += v.sqft
			state.finalGross.number++
			state.finalGross.sqft += v.sqft
			state.finalGross.price += v.price
		})
		// Add em up
		_.forEach(store, (builders, lotType) => {
			_.forEach(builders, (v, builderName) => {
				v.average_home_price = Math.round(v.totalHomePrice / v.total)
				v.average_square_feet = Math.round(v.totalSqft / v.total)
				v.average_ppsqft = Math.round(v.totalHomePrice / v.totalSqft)
			})
		})
		let data = []
		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (v, builderName) => {
				data.push({
					lot_type: lotType,
					builder: builderName,
					total: v.total,
					average_home_price: v.average_home_price,
					average_square_feet: v.average_square_feet,
					average_ppsqft: v.average_ppsqft,
				})
			})
		})
		state.data = data
		this.setState(state)
	}

	buildDaysToCloseTable() {
		let ret = []
		let model = {
			average: 0,
			lowest: 0,
			highest: 0,
			averages: [],
			num_closings: 0,
		}
		let store = {}
		_.forEach(this.props.payload.closings.current, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type || !builder) {
				return
			}
			let path = `["${type.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let m = clone(model)
				_.setWith(store, path, m, Object)
			}
			let c = moment.unix(v.closing_date)
			let s = moment.unix(v.sale_date)
			let daysToClose = c.diff(s, "days")
			store[type.name][builder.name].averages.push(daysToClose)
			store[type.name][builder.name].num_closings++
		})
		_.forEach(store, (builders, lotType) => {
			_.forEach(builders, (v, builderName) => {
				v.average = Math.round(_.sum(v.averages) / v.averages.length)
				v.lowest = _.min(v.averages)
				v.highest = _.max(v.averages)
				ret.push({
					lot_type: lotType,
					builder: builderName,
					average: v.average,
					lowest: v.lowest,
					highest: v.highest,
					num_closings: v.num_closings,
				})
			})
		})

		this.setState({ daysToClose: ret })
	}

	quickStats = () => {
		//? This may be considered actual and not net
		let averages
		if (this.props.payload.closings.current.length > 0) {
			let buck = []
			for (let v of this.props.payload.closings.current) {
				if (!v.price || !v.sqft) {
					//console.log(v)
					continue
				}
				buck.push(v)
			}
			let averageSalesPrice = 0
			let averageSqft = 0
			let averagePpsqft = 0
			let anum = Math.round(_.sumBy(buck, "price") / buck.length)
			let snum = Math.round(_.sumBy(buck, "sqft") / buck.length)
			averageSalesPrice = `$` + anum.toLocaleString()
			averageSqft = snum.toLocaleString()
			if (averageSalesPrice && averageSqft) {
				averagePpsqft = `$` + Math.round(anum / snum)
			}
			averages = {
				averageSalesPrice: averageSalesPrice,
				averageSqft: averageSqft,
				averagePpsqft: averagePpsqft,
			}
		} else {
			averages = {
				averageSalesPrice: 0,
				averageSqft: 0,
				averagePpsqft: 0,
			}
		}
		return (
			<div className="quickStats quickStats--light quickStats--smallPad" style={{ marginTop: 0 }}>
				<ul className="quickStats__list">
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{averages.averageSalesPrice}</div>
							<div className="quickStats__type">Average Closing Price</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{averages.averageSqft}</div>
							<div className="quickStats__type">Average Square Feet</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{averages.averagePpsqft}</div>
							<div className="quickStats__type">Average PPSQFT</div>
						</div>
					</li>
				</ul>
			</div>
		)
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Closing Averages" />
						<div className="content">
							{this.quickStats()}
							<FullTable
								data={this.state.data}
								columns={this.columns()}
								name="closingAverages"
								title="Closing Averages"
							/>
							<h2>Days to Close</h2>
							<FullTable
								data={this.state.daysToClose}
								columns={this.daysToCloseColumns()}
								name="closingAverages_daysToClose"
								title="Closing Averages Days To Close"
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ClosingAverages)
